import { useMemo } from 'react';
import { buildDirectionProperty } from './buildDirectionProperty';
/** Use "start" and "end" CSS properties instead of "right" and "left" */
var createDirection = function (direction) {
    var upper = makeFirstCharUpperCase(direction);
    return {
        direction: direction,
        upper: upper,
        padding: "padding" + upper,
        margin: "margin" + upper,
        borderWidth: "border" + upper + "Width",
        borderStyle: "border" + upper + "Style",
        borderColor: "border" + upper + "Color",
        borderTopRadius: "borderTop" + upper + "Radius",
        borderBottomRadius: "borderBottom" + upper + "Radius"
    };
};
var left = createDirection('left');
var right = createDirection('right');
export function makeReadingDirections(isRtl) {
    if (isRtl === void 0) { isRtl = false; }
    return {
        start: isRtl ? right : left,
        end: isRtl ? left : right,
        readingDirection: buildDirectionProperty(isRtl)
    };
}
export function useReadingDirections(isRtl) {
    var directions = useMemo(function () { return makeReadingDirections(isRtl); }, [isRtl]);
    return directions;
}
function makeFirstCharUpperCase(baseString) {
    var baseArray = baseString.split('');
    baseArray[0] = baseArray[0].toUpperCase();
    return baseArray.join('');
}
